import customChannelResource from 'src/actions/channels/customChannelResource';
import useCustomChannelsConfiguration from 'src/presentation/components/pages/shared/hooks/useCustomChannelsConfiguration';
import useResource from 'src/presentation/hooks/useResource';

export default function useActiveCustomChannels() {
  const { isFeatureEnabled: isCustomChannelsEnabled } = useCustomChannelsConfiguration();
  const { values: customChannels = [], loadingState: customChannelsLoadingState } = useResource(customChannelResource, {
    fetch: isCustomChannelsEnabled,
  });

  return {
    loadingState: customChannelsLoadingState,
    values: customChannels.filter(c => !c.archived),
  };
}
